import { PageMeta } from "@/components/common/Seo/PageMeta"
import ContactUs from "@/components/contact/ContactUs"

const index = () => (
  <>
    <PageMeta
      meta={{
        title: "Contact us",
        description:
          "Questions about our data, pricing or a partnership? Contact the Token Terminal team to book a demo, get API access or discuss a custom data solution.",
      }}
    />
    <ContactUs />
  </>
)

export default index
